module.exports = __webpack_public_path__ + "static/media/bolso (20).4687cbc1.jpg";